import * as React from "react";
import { useTranslation } from "react-i18next";
import { Panel } from "components/bootstrap";
import styles from "./FilterPreview.css";
const FilterPreviewResults = ({ children = void 0, hasError = false }) => {
  const { t } = useTranslation("event_definitions");
  return /* @__PURE__ */ React.createElement(Panel, { className: styles.filterPreview, bsStyle: hasError ? "danger" : "default" }, /* @__PURE__ */ React.createElement(Panel.Heading, null, /* @__PURE__ */ React.createElement(Panel.Title, null, t("filter_preview.title"))), /* @__PURE__ */ React.createElement(Panel.Body, null, children));
};
export default FilterPreviewResults;
